import { render, staticRenderFns } from "./AccountProblem.vue?vue&type=template&id=79c37146&"
import script from "./AccountProblem.vue?vue&type=script&lang=js&"
export * from "./AccountProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports